import Phone from "./phone";

export default class PhoneLogin extends Phone {
  constructor(loginContainer, formSelector, api, errorView) {
    super(loginContainer, formSelector, api, errorView);

    this._captcha.type = `phone-login`;
  }

  sendFormToServer() {
    if (!this._captcha.token) return;

    const data = new FormData(this._form);

    data.set(`smart-token`, this._captcha.token);

    const phoneInputElement = Array.from(this._inputsElements).find((element) => element.type === `tel`);

    this._phoneNumber = phoneInputElement.value;

    this._api.sendLoginPhone(data).then(this._processingServerResponse);
  }
}
